import { Space } from 'antd';
import React, { useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { IntegrationField } from 'api/integrations';
import { Loading } from 'components/atoms/loading';
import { FilterBox } from 'components/molecules/filters/filter-box';
import { Filter } from 'components/molecules/filters/types';
import { defaultFilter } from 'components/molecules/filters/utils';
import {
  booleanTriggerOptionRenderers,
  dateFilterOperationOptions,
  dateTriggerOptionRenderers,
  numberTriggerOptionRenderers,
  selectTriggerOptionRenderers,
  textTriggerOptionRenderers,
} from 'components/organisms/module-settings/integrations/integrations-list/salesforce/automation/create/commons/custom-trigger-options';
import { Modal } from 'components/organisms/module-settings/integrations/integrations-list/salesforce/automation/create/commons/styles';
import { FieldFilter } from 'components/organisms/tasks/filters';
import { useTranslation } from 'hooks/use-translation';
import { convertIntegrationFieldToField } from 'utils/fields-conversion';
import { StatusTypes } from '../use-automation-create';

type TriggerSelectionModalProps = {
  fields: IntegrationField[];
  fieldsStatus: StatusTypes;
  modalVisibility: boolean;
  value?: Filter;
  handleModalVisibility: (visibility: boolean) => void;
  handleSelection: (triggers: Filter) => void;
};
export const TriggerSelectionModal = ({
  fields = [],
  fieldsStatus,
  modalVisibility,
  value,
  handleModalVisibility,
  handleSelection,
}: TriggerSelectionModalProps) => {
  const [triggers, setTriggers] = useState(value ?? defaultFilter);
  const addButtonText = useTranslation(
    'settings.integrations.sf.automation.create.trigger.add_trigger',
  );

  const transformedFields = useMemo(
    () => convertIntegrationFieldToField(fields),
    [fields],
  );

  const validateFields = (_triggers: Filter) => {
    const validatedFields = _triggers.criteria.filter((field) =>
      FieldFilter.isValid(field),
    );

    handleSelection({ type: _triggers.type, criteria: validatedFields });
  };

  return (
    <Modal
      onOk={() => validateFields(triggers)}
      okButtonProps={{ disabled: fieldsStatus === 'loading' }}
      onCancel={() => handleModalVisibility(false)}
      title={
        <FormattedMessage id="settings.integrations.sf.automation.create.trigger.modal.title" />
      }
      visible={modalVisibility}
      okText={<FormattedMessage id="save" />}
      destroyOnClose
    >
      <Space direction="vertical">
        {fieldsStatus === 'loading' ? (
          <Loading />
        ) : (
          <FilterBox
            showFilterType={false}
            addButtonText={addButtonText}
            filter={triggers}
            fields={transformedFields}
            onChange={(val) => {
              setTriggers(val);
            }}
            getFilterOperationTypeOptions={{
              Date: dateFilterOperationOptions,
            }}
            getOperationOptionRenderer={{
              BooleanFilterOperationType: booleanTriggerOptionRenderers,
              NumberFilterOperationType: numberTriggerOptionRenderers,
              TextFieldFilterOperationType: textTriggerOptionRenderers,
              SelectFilterOperationType: selectTriggerOptionRenderers,
              DateFieldFilterOperationType: dateTriggerOptionRenderers,
            }}
          />
        )}
      </Space>
    </Modal>
  );
};
